import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import {
  ModuleModel,
  ModuleStatusEnum,
} from "../../data/models/modules/ModuleModel";
import { firestoreService } from "../../firebase-config";

export function useModuleActions() {
  const migrateOrderToModule = async ({
    currentModuleId,
    targetModuleId,
    orderId,
    userName,
  }: {
    currentModuleId: string;
    targetModuleId: string;
    orderId: string;
    userName: string;
  }) => {
    const modulesRef = collection(firestoreService, "modules");

    const currentRef = doc(firestoreService, "modules", currentModuleId);
    const targetRef = doc(firestoreService, "modules", targetModuleId);

    await updateDoc(currentRef, {
      status: ModuleStatusEnum.CLOSING,
      orderId: null,
      userName: null,
      updatedAt: new Date(),
    });

    await updateDoc(targetRef, {
      status: ModuleStatusEnum.OPENING,
      orderId: orderId,
      userName: userName,
      updatedAt: new Date(),
    });

    return true;
  };

  const getAvailableModules = async ({
    companyCode,
    storeCode,
  }: {
    companyCode: string;
    storeCode: string;
  }): Promise<ModuleModel[]> => {
    const q = query(
      collection(firestoreService, "modules"),
      where("companyCode", "==", companyCode),
      where("storeCode", "==", storeCode),
      where("status", "==", ModuleStatusEnum.CLOSING)
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => new ModuleModel(d.data()));
  };

  return { migrateOrderToModule, getAvailableModules };
}
